<template>
  <div>
    <div class="flex items-center gap-6 mb-4">
      <FilterTabs
        label="View by"
        v-model="portfolioFilter"
        :options="tabOptions"
        @change="onTabChange"
      />
      <div v-if="showCompletedToggle" class="flex items-center gap-2">
        <span class="text-sm">Show completed actions:</span>
        <input
          class="mt-1"
          type="checkbox"
          v-model="showCompleted"
          @change="onCompletedToggle"
        />
      </div>
    </div>

    <div v-if="portfolioFilter === 'My Practices'">
      <div v-if="userEntities.length > 0">
        <Action_Table
          :key="tableKey"
          :entity-id="userEntities[0].id"
          :include-descendants="true"
          :completed-date-is-null="!showCompleted"
        />
      </div>
      <div v-else class="text-gray-500 text-sm py-4">
        No entities assigned to your user account.
      </div>
    </div>

    <div v-else-if="portfolioFilter === 'All Practices'">
      <Action_Table
        :key="tableKey"
        :sql-filters="sqlFilters"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Action_Table from '@/components/Lists/Action_Table.vue'
import FilterTabs from '@/components/widgetcomponents/library/FilterTabs.vue'
import { canAccessFeature } from '@/utils/access';
import { FEATURES } from '@/constants/features';

export default {
  name: 'TabbedActionTable',
  components: {
    Action_Table,
    FilterTabs
  },
  props: {
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const localStorageKey = this.settings?.localStorage_key || 'engage_actions_tab'
    const defaultTab = this.settings?.default_tab || 'My Practices'
    const defaultShowCompleted = this.settings?.default_show_completed || false

    return {
      userEntities: [],
      portfolioFilter: localStorage.getItem(localStorageKey) || defaultTab,
      showCompleted: defaultShowCompleted,
      tableKey: 0
    }
  },
  computed: {
    tabOptions() {
      return [
        { value: 'My Practices', label: 'My Practices' },
        ...(canAccessFeature(FEATURES.COMPONENT_PRACTICE_PARTNER_ALL)
          ? [{ value: 'All Practices', label: 'All Practices' }]
          : []),
      ]
    },
    showCompletedToggle() {
      return this.settings?.show_completed_toggle !== false
    },
    localStorageKey() {
      return this.settings?.localStorage_key || 'engage_actions_tab'
    },
    sqlFilters() {
      if (!this.showCompleted) {
        return {
          action_completed_date: { 'IS NULL': 'true' }
        }
      }
      return undefined
    }
  },
  methods: {
    async fetchUserEntities() {
      try {
        // Get the user's directly linked entity (not all descendants)
        const response = await axios.get('/api/entities/', {
          params: { linked_user_id: 'me' }
        })
        const results = response.data.results || response.data
        this.userEntities = results
      } catch (error) {
        console.error('Error fetching user entities:', error)
        this.userEntities = []
      }
    },
    onTabChange(value) {
      localStorage.setItem(this.localStorageKey, value)
    },
    onCompletedToggle() {
      this.tableKey++
    }
  },
  async mounted() {
    await this.fetchUserEntities()
  }
}
</script>
